import React, { useEffect, useState } from "react";
import { FileSignature, Download } from "lucide-react";
import { AdminShell } from "./AdminShell";
import { adminApi } from "./adminApi";
import { API } from "../api";

const STATUS_LABELS = {
  received: "Reçue", transmitted: "Transmise", precisions: "Précisions", negotiating: "Négociation",
  counter_sent: "Contre-prop.", accepted: "Acceptée", refused: "Refusée", expired: "Expirée", signed: "Signée", draft: "Brouillon",
};
const fmt = (n) => { try { return `${parseInt(n).toLocaleString("fr-FR")} €`; } catch { return n; } };
const dt = (s) => (s ? new Date(s).toLocaleDateString("fr-FR", { day: "2-digit", month: "short", year: "2-digit" }) : "");

export default function AdminOffers({ embedded } = {}) {
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { adminApi.offersAll().then(setData).catch((e) => setErr(e.message || "Accès refusé")); }, []);
  if (err) return <AdminShell embedded={embedded} title="Offres d'achat"><p className="text-red-400 text-sm">{err} — réservé au super administrateur.</p></AdminShell>;
  if (!data) return <AdminShell embedded={embedded} title="Offres d'achat"><p className="text-sm text-[#C19A6B] uppercase tracking-widest animate-pulse">Chargement…</p></AdminShell>;
  const s = data.stats || {};
  return (
    <AdminShell embedded={embedded} title="Offres d'achat — vision globale">
      <div className="grid grid-cols-2 sm:grid-cols-5 gap-3 mb-6" data-testid="admin-offers-stats">
        {[{ l: "Total", v: s.total }, { l: "Reçues", v: s.received }, { l: "Transmises", v: s.transmitted }, { l: "Acceptées", v: s.accepted }, { l: "Refusées", v: s.refused }].map((x) => (
          <div key={x.l} className="bg-[#111114] border border-white/10 p-4"><div className="text-2xl font-light text-white">{x.v || 0}</div><div className="text-[11px] text-zinc-500 mt-1">{x.l}</div></div>
        ))}
      </div>
      {data.offers.length === 0 ? (
        <div className="bg-[#111114] border border-white/10 p-10 text-center"><FileSignature className="w-8 h-8 text-zinc-600 mx-auto mb-3" /><p className="text-sm text-zinc-400">Aucune offre sur la plateforme.</p></div>
      ) : (
        <div className="bg-[#111114] border border-white/10 divide-y divide-white/5" data-testid="admin-offers-table">
          {data.offers.map((o) => (
            <div key={o.id} className="flex items-center gap-4 px-4 py-3" data-testid={`admin-offer-${o.id}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm text-white truncate">{o.buyer?.first_name} {o.buyer?.last_name} <span className="text-zinc-600">·</span> <span className="text-zinc-400">{o.ref}</span></div>
                <div className="text-xs text-zinc-500 truncate">{o.listing_title} · conseiller : {o.owner_name} · {dt(o.created_at)}</div>
              </div>
              <span className="text-sm text-[#C19A6B] shrink-0">{fmt(o.offer?.amount)}</span>
              <span className="text-[10px] uppercase tracking-wider px-2 py-1 border border-white/15 text-zinc-300 shrink-0">{o.expired ? "Expirée" : (STATUS_LABELS[o.status] || o.status)}</span>
              <a href={`${API}/offers/${o.id}/pdf`} target="_blank" rel="noopener noreferrer" className="text-zinc-400 hover:text-[#C19A6B] shrink-0" title="PDF"><Download className="w-4 h-4" /></a>
            </div>
          ))}
        </div>
      )}
    </AdminShell>
  );
}
